import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "custom-font-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_input_select_tags = _resolveComponent("input-select-tags")!
  const _component_tag_suggestion = _resolveComponent("tag-suggestion")!
  const _component_tag_counter_indicator = _resolveComponent("tag-counter-indicator")!
  const _component_selected_tags = _resolveComponent("selected-tags")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h2", null, _toDisplayString(_ctx.$msg('profile.creation.completion.wizard.details.skills.title')), 1),
    _createElementVNode("p", _hoisted_1, [
      _createTextVNode(_toDisplayString(_ctx.$msg('profile.creation.completion.wizard.v2.details.skills.subtitle.one')) + " ", 1),
      _createElementVNode("a", {
        class: "open-bottom-sheet",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openBottomSheet && _ctx.openBottomSheet(...args)))
      }, _toDisplayString(_ctx.$msg('profile.creation.completion.wizard.details.skills.help')), 1)
    ]),
    _createVNode(_component_input_select_tags, {
      id: "keywords_enhanced",
      class: "skills__autocomplete",
      "onUpdate:tag": _ctx.selectSearch
    }, null, 8, ["onUpdate:tag"]),
    _createVNode(_component_tag_suggestion, {
      suggested: _ctx.tagsDifferrenceWith,
      "visible-limit": _ctx.MAX_SUGGESTED_TAGS_COUNT,
      onSelect: _ctx.handlerAddTag
    }, null, 8, ["suggested", "visible-limit", "onSelect"]),
    _createVNode(_component_tag_counter_indicator, {
      tags: _ctx.creationForm.tags,
      "max-tag-count": _ctx.MAX_SELECTED_TAGS_COUNT
    }, null, 8, ["tags", "max-tag-count"]),
    _createVNode(_component_selected_tags, {
      tags: _ctx.creationForm.tags,
      onRemove: _ctx.handlerRemoveTag
    }, null, 8, ["tags", "onRemove"])
  ]))
}